// extracted by mini-css-extract-plugin
module.exports = {"cards":"TeamCards_cards__2N_qy","cards__wrapper":"TeamCards_cards__wrapper__21zW-","cards__wrapper_content":"TeamCards_cards__wrapper_content__3FAyI"};